import { resolveSolarModuleWfsProperties } from '@/utils/map/resolveSolarModuleWfsProperties';

function isHalLink(value) {
  return (
    value &&
    typeof value === 'object' &&
    typeof value.href === 'string' &&
    value.moduleId == null &&
    value.stringId == null &&
    value.arrayId == null
  );
}

function pickFirst(...values) {
  for (const value of values) {
    if (value != null && value !== '') {
      return value;
    }
  }
  return null;
}

function pickNestedSolarModuleIds(solarModule) {
  if (!solarModule || typeof solarModule !== 'object' || isHalLink(solarModule)) {
    return {};
  }

  const stringNode = solarModule.solarString;
  const arrayNode = stringNode?.solarArray ?? solarModule.solarArray;

  return {
    solarModuleSeq: solarModule.id ?? solarModule.seq ?? null,
    moduleId: solarModule.moduleId ?? solarModule.module_id ?? null,
    stringId:
      stringNode?.stringId ??
      stringNode?.string_id ??
      solarModule.stringId ??
      solarModule.solarStringId ??
      null,
    arrayId:
      arrayNode?.arrayId ??
      arrayNode?.array_id ??
      solarModule.arrayId ??
      solarModule.solarArrayId ??
      null
  };
}

/**
 * 결함·모듈 API / WFS / 맵 레이어 속성을 UI 표시용 Array·String·Module ID로 정규화
 */
export function resolveDefectPanelContext(source = {}) {
  const defect = source.defect ?? source;
  const solarModule = source.solarModule ?? defect?.solarModule;
  const moduleLayerProps = source.moduleLayerProps ?? {};

  const fromNested = pickNestedSolarModuleIds(
    typeof solarModule === 'object' ? solarModule : null
  );
  const fromDefect = resolveSolarModuleWfsProperties(defect);
  const fromModule =
    typeof solarModule === 'object' && !isHalLink(solarModule)
      ? resolveSolarModuleWfsProperties(solarModule)
      : { solarModuleSeq: null, moduleId: null, arrayId: null, stringId: null };
  const fromLayer = resolveSolarModuleWfsProperties(moduleLayerProps);

  const solarModuleSeq = pickFirst(
    fromNested.solarModuleSeq,
    defect?.solarModuleSeq,
    source.wfsModuleSeq,
    fromDefect.solarModuleSeq,
    fromModule.solarModuleSeq,
    fromLayer.solarModuleSeq
  );

  const moduleId = pickFirst(
    fromNested.moduleId,
    fromDefect.moduleId,
    fromModule.moduleId,
    fromLayer.moduleId
  );

  const stringId = pickFirst(
    fromNested.stringId,
    defect?.solarStringId,
    defect?.stringId,
    fromDefect.stringId,
    fromModule.stringId,
    fromLayer.stringId
  );

  const arrayId = pickFirst(
    fromNested.arrayId,
    defect?.solarArrayId,
    defect?.arrayId,
    fromDefect.arrayId,
    fromModule.arrayId,
    fromLayer.arrayId
  );

  return { solarModuleSeq, moduleId, arrayId, stringId };
}

export function formatDefectPanelContextDisplay(ctx, fallback = '-') {
  const fmt = (value) => (value == null || value === '' ? fallback : value);
  const moduleDisplay = ctx?.moduleId ?? ctx?.solarModuleSeq ?? fallback;
  return {
    arrayId: fmt(ctx?.arrayId),
    stringId: fmt(ctx?.stringId),
    moduleId: fmt(moduleDisplay)
  };
}
